/**
 * SkillDelivery Platform
 * InitialsBadge — rounded-square avatar with up to 2 uppercase initials.
 * Used in BrandSidebar when the customer has no brand_logo_url, and as
 * the error fallback when a logo URL 404s.
 */
import React from 'react';

/**
 * @param {object} props
 * @param {string} props.initials  Up to 2 chars (server pre-computes).
 * @param {string} [props.color]   Hex colour; defaults to brand cyan.
 * @param {number} [props.size=44]
 */
export default function InitialsBadge({ initials, color, size = 44 }) {
  const safeInitials = (initials || '?').slice(0, 2).toUpperCase();
  const bg = color && /^#[0-9A-Fa-f]{6}$/.test(color) ? color : '#0891b2';
  // Pick white or near-black text for readability (relative luminance).
  const fg = _readableTextColor(bg);
  return (
    <div
      aria-hidden="true"
      style={{
        width: size,
        height: size,
        borderRadius: 10,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: bg,
        color: fg,
        fontWeight: 700,
        fontSize: Math.round(size * 0.4),
        letterSpacing: '0.5px',
        flexShrink: 0,
        boxShadow: '0 1px 2px rgba(15,23,42,0.08)'
      }}
    >
      {safeInitials}
    </div>
  );
}

function _readableTextColor(hex) {
  try {
    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);
    // Perceived brightness; threshold ~140.
    const brightness = (r * 299 + g * 587 + b * 114) / 1000;
    return brightness > 140 ? '#0f172a' : '#ffffff';
  } catch (_) {
    return '#ffffff';
  }
}
